export const DEFAULT_TITLE = 'Autodesk Construction Cloud';

export const SCROLL_CONTAINER_ID = 'scroll-to-top'; //taken from project list providers remote

export const EXO_SKELETON_SCOPE_NAME = 'ACCExoSkeleton';
